import React, { useState } from 'react';

import { Input, InputProps } from 'components';

const RequiredInput: React.FC<InputProps> = props => {
  const { error, ...restProps } = props;
  const [isDirty, setIsDirty] = useState(false);

  const errorMessage = isDirty ? error : '';

  return (
    <Input
      {...restProps}
      required
      onBlur={() => setIsDirty(true)}
      position="after"
      error={errorMessage}
    />
  );
};

export default RequiredInput;
